export type NumpadKey = string | 'backspace' | null;

export const NUMPAD_KEYS: NumpadKey[][] = [
	['1', '2', '3'],
	['4', '5', '6'],
	['7', '8', '9'],
	[null, '0', 'backspace'],
];
